<nb-card class="orbi-distribute">
  <nb-card-header>
    <h4>{{ titleKey | translate }}</h4>
  </nb-card-header>

  <nb-card-body>
    <div class="scene-frame">
      <!-- Bühne in Lab-Maßen (220px-Haupt-Orbi, Schwarm-Mittelpunkt = Orbi-
           Mittelpunkt). DOM-Reihenfolge des Schwarms wie in
           core/mini-orbi-swarm.js: Ring, Funken, dann je Mini Schatten + Körper. -->
      <div class="scene" aria-hidden="true">
        <div class="scene__main">
          <app-agent-orb
            #mainOrb
            type="tutor"
            [size]="212"
            [externalSequence]="sequenceId"
          ></app-agent-orb>
        </div>

        <div
          class="mini-orbi-swarm"
          [style.--swarm-color-a]="swarmColors.a"
          [style.--swarm-color-b]="swarmColors.b"
          [style.--swarm-color-c]="swarmColors.c"
        >
          <div class="mini-orbi-swarm__ring" #ring></div>
          <i
            *ngFor="let spark of sparks"
            #spark
            class="mini-orbi-swarm__spark"
            [style.--spark-color]="spark.color"
            [style.--spark-length]="spark.length"
          ></i>
          <ng-container *ngFor="let size of miniSizes">
            <div class="mini-orbi__shadow" #miniShadow></div>
            <div class="mini-orbi__body" #miniBody [style.--mini-orbi-size]="size + 'px'">
              <app-agent-orb
                type="tutor"
                [size]="size - 8"
                [externalSequence]="sequenceId"
              ></app-agent-orb>
            </div>
          </ng-container>
        </div>

        <div
          *ngIf="result"
          class="scene__result"
          [class.scene__result--partial]="result.outcome === 'partial'"
          [class.scene__result--failed]="result.outcome === 'failed'"
        >
          <nb-icon [icon]="resultIcon"></nb-icon>
        </div>
      </div>
    </div>

    <p class="orbi-distribute__text" aria-live="polite">
      {{ messageKey | translate: messageParams }}
    </p>
    <p *ngIf="result?.reason" class="orbi-distribute__text">{{ result?.reason }}</p>
    <p *ngIf="backgroundAvailable && !done" class="orbi-distribute__hint">
      <nb-icon icon="info-outline"></nb-icon>
      <span>{{ 'dialogs.orbiDistribute.sync.background' | translate }}</span>
    </p>
  </nb-card-body>

  <nb-card-footer *ngIf="done || backgroundAvailable">
    <button *ngIf="done; else continueButton" type="button" nbButton status="primary" (click)="close()">
      {{ 'buttons.close' | translate }}
    </button>
    <ng-template #continueButton>
      <button type="button" nbButton status="primary" (click)="close()">
        {{ 'dialogs.orbiDistribute.continueWorking' | translate }}
      </button>
    </ng-template>
  </nb-card-footer>
</nb-card>
